

<template>
	<div class="product-infos px-3 px-sm-10 py-7">
		<a @click="$emit('close-clicked', createEventParameters($event))" class="close p-2">
			<i class="fal fa-times"></i>
		</a>
		<div class="content d-lg-flex py-4">

			<figure class="order-md-1 col-10 px-10 px-md-0 mx-auto mx-sm-0 mb-10 mb-sm-0 col-sm-5 col-lg-4 float-sm-right" v-if="product.img">
				<img :src="product.img" class="img-fluid w-100" />
			</figure>

			<div class="col-lg-8 order-md-0">
				<h1 v-if="product.title" v-html="product.title"></h1>
				<h2 v-if="product.subtitle" v-html="product.subtitle"></h2>
				<div class="pt-5 pb-10" v-if="product.bodytext" v-html="product.bodytext"></div>
				
				<a v-for="pdf in product.pdf" @click="showPdf($event, pdf)" class="btn btn-primary mr-5">
					Mehr Infos
				</a>
			</div>
			
		</div>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

export default {
	store,
	props: ['product'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},

	mounted() {
	},

	methods: {
		showPdf( event, pdf ) {
			EventBus.$emit('show-pdf', this.createEventParameters(event, pdf));
		},
		createEventParameters( event, pdf ) {
			return Object.assign({
				product: this.product,
				pdf: pdf,
				$el: this.$el,
				originalEvent: event,
			});
		}
	}

}
</script>


<style scoped lang="scss">

	a {
		cursor: pointer;
	}

	.product-infos {

		background: #fff;
		border: 5px solid #66bbb4;
		box-shadow: 0 0 8px rgba(#000, 0.3);
		font-family: $font-condensed;
		font-size: 1rem;
		color: #555;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;

		@include position( absolute, 0 0 0 0, 100 );
		
		@media ($min-device-width-md) {
			font-size: 1.1rem;
			@include position( absolute, 20px 20px 20px 20px, 100 );
		}

		@media ($min-device-width-lg) {
			@include position( absolute, 50% auto auto 50%, 100 );
			bottom: auto;
			right: auto;
			transform: translate( -50%, -50% );
			width: 80%;
			max-width: 1000px;
			overflow-y: visible;
		}
		@media ($min-device-width-xl) {
			width: 80%;
			max-width: 1000px;
		}
	}

	.btn-primary {
		color: #fff;
		border: none;
		border-radius: 0;
		background: #004176;
		text-transform: uppercase;
		&:hover {
			color: #fff;
			background: lighten(#004176, 15%);
		}
	}

	.close {
		font-size: 2.5rem;
		@include position( fixed, 10px 15px auto auto, 100 );
		@media ($min-device-width-md) {
			@include position( absolute, 10px 15px auto auto, 100 );
		}
	}

	h1, h2 {
		font-family: $font-condensed;
		text-transform: uppercase;
		font-size: 1.5rem;
		@media ($min-device-width-md) {
			font-size: 2rem;
		}
		margin: 0 0 0.1rem 0;
		letter-spacing: 0.01em;
		color: #004982;
	}
	h1 {
		font-weight: 600;
	}
	h2 {
		font-weight: 300;
	}
	
</style>

<style lang="scss">
	.product-infos {
		ul {
			padding: 0 0 0 20px;
			margin: 0;
		}
		p {
			margin-bottom: 0.3rem;
		}
	}
	.pflege ~ .product-infos {
		border-color: #5db9da;
	}
</style>
